import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Output } from '@angular/core';
import { Renderer } from '@df/ng/renderer';
import { injectTimeoutService } from '@df/ng/timeout.service';

@Component({
    selector: 'product-mobile-footer',
    styleUrl: './product-mobile-footer.scss',
    templateUrl: './product-mobile-footer.html',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductMobileFooterComponent implements AfterViewInit {
    @Output() hideSizeOptions = new EventEmitter<void>();

    protected readonly timeoutService = injectTimeoutService();

    constructor(
        private renderer: Renderer,
        private elementRef: ElementRef
    ) {}

    ngAfterViewInit() {
        this.timeoutService.setTimeout(() => {
            const el = this.elementRef.nativeElement;
            if (el) {
                this.renderer.setStyle(el, 'visibility', 'visible');
            }
        }, 500);
    }

    toggle(visible: boolean) {
        this.renderer.setClass(this.elementRef.nativeElement, 'is-hidden', !visible);

        if (!visible) {
            this.hideSizeOptions.emit();
        }
    }
}
